import classNames from 'classnames'
import React, { useRef } from 'react'
import { SwiperRef } from 'swiper/react'

import { Button, RichText as RichTextC } from '@src/quince-components/src'
import Swiper from '@src/quince-components/src/atoms/swiper'
import POSITIONS from '@src/quince-site-common/src/constants/positions'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import RichText from '@src/quince-site-common/src/domains/RichText'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { makeButtonProps } from '@src/quince-site-pdp/src/molecules/newLongFormModuleCTA'

import { Image } from '../image'
import { DOTS_POSITION, NAV_POSITION } from '../swiper/Swiper'
import Video, { VIDEO_LOADING_TYPE, VIDEO_PRELOAD_TYPE } from '../video'

import styles from './featureSectionEight.module.scss'

interface FeatureSectionEightProps {
  section: CustomSection
}
function FeatureSectionEight({ section }: FeatureSectionEightProps) {
  const deviceInfo = useDeviceInfo()
  const carouselRef = useRef<SwiperRef | null>(null)
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP

  return (
    <div className={classNames(styles.wrapper, section.classNames)}>
      <div className={section.position === POSITIONS.LEFT ? styles.row : styles.rowReverse}>
        <div className={styles.mediaContent}>
          {section?.images && section?.images.length > 0 && section.images[0] ? (
            <div className={styles.mediaWrapper}>
              <Image {...section.images[0]} loading={'lazy'} className={styles.mediaWrapper} />
            </div>
          ) : section?.videos?.length && section.videos[0] ? (
            <div className={styles.mediaWrapper}>
              <Video
                {...section.videos[0]}
                muted
                autoplay
                loop
                limitedControls
                controls={false}
                loadingType={VIDEO_LOADING_TYPE.Lazy}
                preload={VIDEO_PRELOAD_TYPE.Auto}
                isPresentation
                wrapperClassName={styles.mediaWrapper}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className={styles.textContent}>
          <Swiper
            id="feature-section-8-carousel"
            showDots={!isDesktop}
            showNavigator={isDesktop}
            numberOfVisibleSlides={1}
            variableWidth={!isDesktop}
            navPosition={NAV_POSITION.RIGHT}
            dotsPosition={DOTS_POSITION.TOP}
            freeMode={false}
            ref={carouselRef}
            initialSlide={0}
            virtualOptions={{ enabled: true }}
            arrowWrapperClass={styles.arrowWrapperClass}
          >
            {section?.subSections?.map((section, idx) => (
              <div key={idx}>
                <div className={styles.slideContent}>
                  {section?.images && section?.images.length > 0 && section.images[0] && (
                    <div className={styles.iconWrapper}>
                      <Image {...section.images[0]} loading={'lazy'} height={40} />
                    </div>
                  )}
                  <text className={styles.headline}>{section?.title}</text>
                  {section?.richTexts && (
                    <RichTextC
                      {...RichText.makeRichTextProps(section.richTexts[0])!}
                      className={classNames(
                        RichText.makeRichTextProps(section.richTexts[0])?.className,
                        styles.subText,
                      )}
                    />
                  )}
                  {section?.buttons && section?.buttons.length > 0 && section.buttons[0] && (
                    <Button classNames={[styles.ctaBtn]} {...makeButtonProps(section.buttons[0])} />
                  )}
                </div>
              </div>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}
export default FeatureSectionEight
